import { render, staticRenderFns } from "./DoctorAvatarEditorModal.vue?vue&type=template&id=1ef07b36&scoped=true&"
import script from "./DoctorAvatarEditorModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorAvatarEditorModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorAvatarEditorModal.vue?vue&type=style&index=0&id=1ef07b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef07b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef07b36')) {
      api.createRecord('1ef07b36', component.options)
    } else {
      api.reload('1ef07b36', component.options)
    }
    module.hot.accept("./DoctorAvatarEditorModal.vue?vue&type=template&id=1ef07b36&scoped=true&", function () {
      api.rerender('1ef07b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DoctorAvatarEditor/components/DoctorAvatarEditorModal.vue"
export default component.exports